import * as ca_ES from 'd3-time-format/locale/ca-ES.json'
import * as cs_CZ from 'd3-time-format/locale/cs-CZ.json'
import * as da_DK from 'd3-time-format/locale/da-DK.json'
import * as de_CH from 'd3-time-format/locale/de-CH.json'
import * as de_DE from 'd3-time-format/locale/de-DE.json'
import * as en_CA from 'd3-time-format/locale/en-CA.json'
import * as en_GB from 'd3-time-format/locale/en-GB.json'
import * as en_US from 'd3-time-format/locale/en-US.json'
import * as es_ES from 'd3-time-format/locale/es-ES.json'
import * as es_MX from 'd3-time-format/locale/es-MX.json'
import * as fi_FI from 'd3-time-format/locale/fi-FI.json'
import * as fr_CA from 'd3-time-format/locale/fr-CA.json'
import * as fr_FR from 'd3-time-format/locale/fr-FR.json'
import * as he_IL from 'd3-time-format/locale/he-IL.json'
import * as hu_HU from 'd3-time-format/locale/hu-HU.json'
import * as it_IT from 'd3-time-format/locale/it-IT.json'
import * as ja_JP from 'd3-time-format/locale/ja-JP.json'
import * as ko_KR from 'd3-time-format/locale/ko-KR.json'
import * as mk_MK from 'd3-time-format/locale/mk-MK.json'
import * as nl_NL from 'd3-time-format/locale/nl-NL.json'
import * as pl_PL from 'd3-time-format/locale/pl-PL.json'
import * as pt_BR from 'd3-time-format/locale/pt-BR.json'
import * as ru_RU from 'd3-time-format/locale/ru-RU.json'
import * as sv_SE from 'd3-time-format/locale/sv-SE.json'
import * as tr_TR from 'd3-time-format/locale/tr-TR.json'
import * as uk_UA from 'd3-time-format/locale/uk-UA.json'
import * as zh_CN from 'd3-time-format/locale/zh-CN.json'

export const lookup = {
	ca_ES: ca_ES,
	cs_CZ: cs_CZ,
	da_DK: da_DK,
	de_CH: de_CH,
	de_DE: de_DE,
	en_CA: en_CA,
	en_GB: en_GB,
	en_US: en_US,
	es_ES: es_ES,
	es_MX: es_MX,
	fi_FI: fi_FI,
	fr_CA: fr_CA,
	fr_FR: fr_FR,
	he_IL: he_IL,
	hu_HU: hu_HU,
	it_IT: it_IT,
	ja_JP: ja_JP,
	ko_KR: ko_KR,
	mk_MK: mk_MK,
	nl_NL: nl_NL,
	pl_PL: pl_PL,
	pt_BR: pt_BR,
	ru_RU: ru_RU,
	sv_SE: sv_SE,
	tr_TR: tr_TR,
	uk_UA: uk_UA,
	zh_CN: zh_CN
}

